import { Component, OnInit, OnDestroy, AfterViewInit, DoCheck } from '@angular/core';
import { TranslateService } from "@ngx-translate/core";
import { EmitterService } from '../../services/emitter.service';
import { AjaxService } from '../../services/ajax.service';
import { UserDetailsService } from '../../services/user-details.service';
import { ProfileSettingService } from '../../services/profile-setting.service';
import { BonusService } from './services/bonus.service';
import { Utility } from '../../shared/utility/utility';
import { PnpZimplerService } from '../../services/pnp-zimpler.service';
import * as _ from 'underscore';
import { environment } from '../../../environments/environment';
import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";
import { swiperPaginationConfig } from '../../shared/utility/config';
import { GameWindowService } from '../../services/gameWindow.services';
import Swiper, { Navigation, Pagination } from 'swiper';
import * as $ from "jquery";

@Component({
  selector: 'app-bonuses',
  templateUrl: './bonuses.component.html',
  styleUrls: ['./bonuses.component.scss']
})
export class BonusesComponent implements OnInit, OnDestroy, AfterViewInit,DoCheck {
  serverError;
  bonusDetails;
  userCurrencySymbol;
  userDetail;
  langCode;
  cancelBonusID: string = "";
  cancelBonusName: string = "";
  eligibleBonusList;
  siteUrlPath: string = environment.siteUrl;
  webisteCode = environment.website_code;
  mediaUrlPath = environment.mediaPath;
  swiperTagConfig = swiperPaginationConfig;
  destroy$: Subject<boolean> = new Subject<boolean>();
  allGamesData;
  freeSpinGamesData;
  filteredFreeSpinGames;
  showFreeSpinGames = false;
  gameUrlPath = environment.gamePath;
  bonusLoaded = false;
  paginationItems;
  currencyCode: any;
  swiperInstance;
  current: number = 0;
  isActiveIndex:number = 0;

  constructor(
    private emitterService: EmitterService,
    private ajaxService: AjaxService,
    public userService: UserDetailsService,
    private profileSettingService:ProfileSettingService,
    private translationService: TranslateService,
    private utils: Utility,
    private bonusService : BonusService,
    private pnpService: PnpZimplerService,
    private gmService:GameWindowService
  ) {
    setTimeout(()=>{
      this.getBonusDetails();
    },1000)
    
    this.getGamesData();
    this.emitterService.updateBonusDetails$.subscribe(()=>{
      this.getGamesData();
     })
     this.userDetail = userService
     this.langCode = localStorage.getItem('langCode')
     this.emitterService.langCodeSource$.pipe(takeUntil(this.destroy$)).subscribe(langCode =>{
       this.langCode = langCode;
       
     })
     this.currencyCode = this.userService.getUserCurrencyCode();
 
  }
 

  ngOnInit() {
    this.cancelBonusID = "";
    this.cancelBonusName = "";
    if(!this.userService.getUserCurrencyDetails()){
      this.ajaxService.getProfileBalanceCurrency().pipe(takeUntil(this.destroy$)).subscribe(profileBalanceCurrency => {
        let obj = {};
        if (profileBalanceCurrency) {
          this.userCurrencySymbol =profileBalanceCurrency["currencyDetails"].symbol;
        }
      });
    }else{
      this.userCurrencySymbol = this.userService.getUserCurrencyDetails().symbol;
    }
    this.currencyCode = this.userService.getUserCurrencyCode();
    this.emitterService.broadcastActiveTabChangeSource("bonuses");
   

    Promise.resolve(this.profileSettingService.getProfileData(false))
    .then(
      profileData =>{
        this.userDetail = this.userService.getUserProfileDetails();
      }
    )
    this.gmService.getAllCasinoGames().subscribe(gamesData => {
      this.getGamesData(gamesData);
    });
  }

  ngAfterViewInit(): void {
    this.initializeSwiper();
  }
  getGamesData(gamesData?) {
    this.eligibleBonusList =  this.bonusService.eligibleBonusList;
    this.freeSpinGamesData = this.bonusService.activeFreeSpinsData;
    this.allGamesData = gamesData ? gamesData : this.gmService.getAllSlotData();
    if (this.allGamesData !== null && this.allGamesData.length > 0 && this.freeSpinGamesData?.length) {
          
          let filteredGames = this.allGamesData.filter(allGamesDataIndexVal => this.freeSpinGamesData.some(freeSpinGamesDataIndexVal => allGamesDataIndexVal.gameCode === freeSpinGamesDataIndexVal['freeSpinGameIds'][0]));
          this.filteredFreeSpinGames= [];
          this.freeSpinGamesData.filter((bonusSpin)=>{
            filteredGames.filter((game)=>{
              if(game.gameCode == bonusSpin.freeSpinGameIds[0]){
                if(typeof bonusSpin.offeredDate == 'string'){
                  bonusSpin.freespinExpiryDate = parseFloat(bonusSpin.freespinExpiryDate)
                }
                game.expDate = bonusSpin.freespinExpiryDate;
                this.filteredFreeSpinGames.push(game)
              }
            })
          })
          
          let eligibleSpecialBonusList = this.bonusService.getSpecialBonus();
          
          if(eligibleSpecialBonusList && eligibleSpecialBonusList.length){
            eligibleSpecialBonusList.filter((item) => {
              if(item && item.gameIds && item.gameIds.length){
                this.filteredFreeSpinGames.forEach((game) => {
                  if(item.gameIds[0] === game.gameCode){
                    game.expDate = item.campaignEndDate;
                  }
                })
              }
            })
          }
         
          if(this.filteredFreeSpinGames?.length> 0){
            this.showFreeSpinGames = true;
           
            this.utils.gtmEvent("freeSpinsLaunched", {
              freespinsLaunched: "LAUNCHED"
            });
          }else{
            this.showFreeSpinGames = false;
          }
        }
        this.eligibleBonusList = this.eligibleBonusList.flatMap((bonusList) => {
          // If the gameIds array is empty, return the object as is
          if (bonusList.gameIds.length === 0) {
            return [bonusList];
          }
    
          // Otherwise, map over each gameId to create a new object for each gameId
          return bonusList.gameIds.map((gameId) => {
            // Find the game with the matching gameCode
            const game = this.allGamesData.find((game) => game.gameCode === gameId);
    
            // Create a new object with the same properties but with only the current gameId
            return {
              ...bonusList, // Preserve other properties of bonusList
              gameIds: [game ? game.name : gameId] // Set the gameIds array to only contain the current gameId
            };
          });
        });
        
        setTimeout(()=>{
          this.paginationItems = [...this.eligibleBonusList,...this.freeSpinGamesData];
        }, 200)
  }

  gameLauncher(gameCode, gameLaunchUrlPath): void {
    /* W2CD-2088 multilingual game launch changes can be modified here */
    this.userService.gamePlayLaunchChecks(gameCode, gameLaunchUrlPath['en']);
    this.utils.gtmEvent("freeSpinsActivated", {
      freespinsActivated: "ACTIVE"
    });
  }
  
  getBonusDetails():any{
    let activeBonusData = this.bonusService.activeBonusList;
    if(!activeBonusData?.length){
      Promise.resolve(this.ajaxService.psGet("",'/ajax/Bonus/activeBonusDetails'))
      .then(data => {
        this.current = 0;
       this.updateActiveBonusData(data)
      }).catch(()=>{
        this.bonusLoaded = true;
      })
    }else{
     this.updateActiveBonusData(this.bonusService.activeBonusList)
    }
   
  }
  ngDoCheck(): void {
    this.swiperTransform();
  }
  swiperTransform() {
    this.isActiveIndex = this.swiperInstance?.snapIndex ? this.swiperInstance.snapIndex : 0 
    const activeIndex = $('.bonus-cards-swiper > .swiper-wrapper').children('.swiper-slide-active').index();
    const ww = document.body.clientWidth;
    let translateValue :any;
      if (ww < 360) {
        translateValue = -92.8;
      } else if (ww < 993){
        translateValue = -92;
      } else {
        translateValue = -94.3;
      }   
      $('.bonus-cards-swiper > .swiper-wrapper').css('transform', `translate(${translateValue * activeIndex + "%"} , 0)`); 
  }
 
  initializeSwiper() {
    setTimeout(() => {
     this.swiperInstance =  new Swiper(('.bonus-cards-swiper'), {
        slidesPerView: 1.059,
        slidesPerGroup: 1,
        spaceBetween: 10,
        breakpoints:{
          '640': {
            slidesPerView: 1.05
          }
        }

      });
    });
  }

  updateActiveBonusData(data) {
    if(data.length){
      this.bonusDetails= data;
      this.bonusDetails = this.bonusDetails.filter(bonus=>{
         if(!bonus.isFreeSpinBonus || (bonus.isFreeSpinBonus && bonus.isFreeSpinsCompleted)){
            return bonus;
         }
      })
    }else {
      this.bonusDetails = [];
    }
    this.bonusLoaded = true;
    
  }
  changeSwiper(ind){
   this.swiperInstance.slideTo(ind);
  }
  
  getTranslateTextAndObject(bonus) {
    let object =  {
      jsonKey: undefined,
      jsonKey2: undefined,
      eligibleBonusPropertyValues : {
        maxOfferValue: this.setEligibleBonusPropertyValues('maxOfferValue', bonus),
        userCurrencySymbol: this.userCurrencySymbol,
        minDepositValue: this.setEligibleBonusPropertyValues('minDepositValue', bonus),
        percentageValue : this.setEligibleBonusPropertyValues('percentageValue', bonus),
        freespinCountOrPct :this.setEligibleBonusPropertyValues('freespinCountOrPct', bonus),
        gameName : bonus.gameIds
      }
    }
    switch (bonus['amountType']) {
      case 'ABS':
        object['jsonKey'] = 'rewards.rewards_ABSFreeSpin'
        object['jsonKey2'] = 'rewards.rewards_ABSFreeSpin2'
        if (!bonus['currencyTier'][this.currencyCode][0]['freespinCountOrPct']) {
          object['jsonKey'] = 'rewards.rewards_ABSNoFreeSpin'
          object['jsonKey2'] = 'rewards.rewards_ABSNoFreeSpin2'
        }
        break;
      case 'PCT':
        object['jsonKey'] = 'rewards.rewards_ABSNoFreeSpin'
        object['jsonKey2'] = 'rewards.rewards_PCTOnlyFreeSpin';
        if (bonus['currencyTier'][this.currencyCode][0]['freespinCountOrPct'] && bonus['currencyTier'][this.currencyCode][0]['percentageValue']) {
          object['jsonKey'] = 'rewards.rewards_ABSNoFreeSpin'
          object['jsonKey2'] = 'rewards.rewards_PCTBothSpinPercentage';
        } else if (bonus['currencyTier'][this.currencyCode][0]['percentageValue'] && !bonus['currencyTier'][this.currencyCode][0]['freespinCountOrPct']) {
          object['jsonKey'] = 'rewards.rewards_ABSNoFreeSpin'
          object['jsonKey2'] = 'rewards.rewards_PCTOnlyPercentage';
        }
        break;
    }
    return object;
  }

  setEligibleBonusPropertyValues(type, bonus){
    switch(type){
      case 'maxOfferValue':
        return bonus['currencyTier'][this.currencyCode][0]['maxOfferValue'] ? bonus['currencyTier'][this.currencyCode][0]['maxOfferValue'] / 100 : 0;
      case 'freespinCountOrPct':
        return bonus['currencyTier'][this.currencyCode][0]['freespinCountOrPct'];
      case 'minDepositValue':
        return bonus['currencyTier'][this.currencyCode][0]['minDepositValue'] ? bonus['currencyTier'][this.currencyCode][0]['minDepositValue'] / 100 : 0;
      case 'percentageValue':
        return bonus['currencyTier'][this.currencyCode][0]['percentageValue'];
    }
  }
  openDeposit(bonusDetails){
    this.bonusService.setEligibleBonusCode(bonusDetails);

    if((this.userService.checkZimplerDepositOpen())) {
      this.pnpService.openZimplerDeposit();
    } else if(!this.userService.checkIsPNPUser()){
      this.emitterService.broadcastModalState({ name: "paymentModal", state: "open", cashierType: "deposit" });
    }
  this.closeMenu();
  }

  closeMenu(){
    this.goBack() ;
    this.emitterService.broadCastSideMenuStatus(false);
    this.emitterService.broadCastToggleNavPanel(false);
    this.utils.setIsSideMenuOpened(false);
  }
  
 getGameImg(bonus){
   let game = this.allGamesData.filter(item => bonus && bonus.gameIds && bonus.gameIds.length && bonus.gameIds[0] === item.gameCode);
   if(game && game.length)
    return `${this.siteUrlPath}/${this.gameUrlPath}/${game[0].gameCode}/${game[0].gameCode}.jpg`
}
  cancelBonus() {
    this.bonusService.dropBonus(this.cancelBonusID).pipe(takeUntil(this.destroy$)).subscribe(response => {
      this.closeModal("dropbonusConfirmation");
      this.cancelBonusID = "";
      this.cancelBonusName = "";
      if (!response) {
        this.serverError = this.translationService.instant('errors.error');
        this.emitterService.broadcastserverError(this.serverError, "/myaccount/bonuses");
        return;
      }
      if (response["status"] === "SUCCESS" && response["bonusDropped"] === "SUCCESS") {
        this.bonusService.activeBonusList = [];
        this.getBonusDetails();
      } else {
        this.serverError = this.translationService.instant('errors.dropbonusfail');
        this.emitterService.broadcastserverError(this.serverError, "");
        return;
      }
    });
  }
  closeModal(modalId: string) {
    this.cancelBonusID = "";
    this.cancelBonusName = "";
    this.utils.closeModal(modalId);
  }
  openModal(modalId, bonusID, bonusName) {
    this.cancelBonusID = bonusID;
    this.cancelBonusName = '"'+bonusName + ' " ?';
    this.utils.openModal(modalId);

  }
  getDate(timeStamp){
    return timeStamp ? new Date(timeStamp) : new Date();
  }
  goBack(){
    this.emitterService.broadCastToggleNavPanel({isBack:true, opened:true});
    this.utils.setIsSideMenuOpened(true);
  }
  
  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

}
